var e,t;import r from"react";import i from"../utils/styled.js";import{Effects as l,shapeFilterToCSS as a}from"../utils/filters.js";const n=i("div")`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  width: calc(33% - 16px);
  gap: 8px;
  cursor: pointer;
`,o=i("span")`
  text-align: center;
`,s=i("div")`
  position: relative;
  border-radius: 10px;
  box-sizing: border-box;
  height: 90px;
`,c=i("img")`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
`,d=i("div")`
  left: -4px;
  top: -4px;
  bottom: -4px;
  right: -4px;
  display: flex;
  position: absolute;
  border-radius: 15px;
  padding: 2px;
  transition: 0.2s border;
  border: 2px solid ${e=>e.active?"white":"transparent"};
`;export const EffectCard=({title:e,imageSrc:t,effect:i,onClick:l,active:a})=>{const c=g(i);return r.createElement(n,{onClick:l},r.createElement(s,null,r.createElement(d,{active:a}),r.createElement(c,{src:t})),r.createElement(o,null,e))};const p=i(c)`
  filter: sepia(1);
`,u=i(c)`
  filter: grayscale(1);
`,f=i(c)`
  filter: ${null===(e=a(l.warm))||void 0===e?void 0:e.filter};
`,m=e=>{const{html:t,filter:i}=a(l.cold);return r.createElement(r.Fragment,null,r.createElement("div",{style:{display:"none"},dangerouslySetInnerHTML:{__html:t}}),r.createElement(c,Object.assign({style:{filter:i}},e)))},x=i(c)`
  filter: ${null===(t=a(l.natural))||void 0===t?void 0:t.filter};
`,g=e=>{switch(e){case l.sepia:return p;case l.grayscale:return u;case l.warm:return f;case l.cold:return m;case l.natural:return x;default:return c}};